<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    top="10vh"
    width="90%"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <choose-material
      ref="chooseMaterialInner"
      :productLine="productLine"
      :detailMaterialCategoryCode="detailMaterialCategoryCode"
      :mainMaterialCategoryCode="mainMaterialCategoryCode"
      :type="type"
    />
    <span slot="footer">
      <el-button v-if="!type" size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button v-if="type" size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button v-if="type" type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    productLine: String,
    detailMaterialCategoryCode: String,
    mainMaterialCategoryCode: String,
    type: String,
  },
  methods: {
    confirm() {
      const data = this.$refs.chooseMaterialInner.choiceData()
      if (!data) return

      this.$emit('confirm', data)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
